import Component from '../abstracts/Component';
import GalleryManager from '../utils/GalleryManager';
import FiltersComponent from '../components/FiltersComponent';

export default class ShortcutComponent extends Component {

  get SELECTORS() {
    return {
      arrowRight: '[data-arrow-right]',
      arrowLeft: '[data-arrow-left]',
      scroller: '[data-simplebar-wrapper]',
      itemsContainer: '[data-shortcut-items]',
      item: '[data-shortcut-item]',
      titleContainer: '.shortcut__title-container',
      input: 'input[type="radio"]',
      //END WIP
      responsesContainer: '[data-shortcut-products]',
      firstShortcut: '#shortcut_0',
      breadcrumbsWrapper: '.breadcrumbs__wrapper',
      defaultLastBreadcrumb: '[data-last-breadcrumb]'
    };
  }

  get QUERY_PARAMS() {
    return {
      base: '?save=false&q=:topRated',
      end: ':sortBy:topRated&size=36',
    }
  }

  get COMPONENTNAME() {
    return 'ShortcutComponent';
  }

  constructor(htmlEl) {
    super(htmlEl);

    this.firstShortcut = document.querySelector(this.SELECTORS.firstShortcut);
    this.FiltersComponent = new FiltersComponent(htmlEl);

    this.breadcrumbsWrapper = document.querySelector(this.SELECTORS.breadcrumbsWrapper);
    this.defaultLastBreadcrumb = document.querySelector(this.SELECTORS.defaultLastBreadcrumb);

    this.urlParams = new URLSearchParams(window.location.search);
  }

  render() {
    super.render();
    this.galleryManager = new GalleryManager(
      this.SELECTORS,
      this.$component,
      this.moduleLoader
    );
    this.bindEvents();
    window.addEventListener('pageshow', () => this.restoreShortcutFromUrl());
  }


  bindEvents() {
    if (this.firstShortcut != null && this.firstShortcut != 'undefined') {
      this.firstShortcut.addEventListener('click', (e) => {
        if (!e.currentTarget.classList.contains('selected')) {
          if (e.currentTarget.dataset.isLink === "true") {
            window.open(e.currentTarget.dataset.href, '_self');
          } else {
            this.FiltersComponent.filterQuery(false, '', true);
            this.hideBreadcrumbs();
            this.removeShortcutCodeFromUrl();
          }
        }
      });
    }

    document.querySelectorAll(this.SELECTORS.item).forEach((item) => {
      const isFirstItem = item.id === 'shortcut_0';

      if (!this.urlParams.get('code')) {
        if (window.location.pathname === item.dataset.href) {
          item.classList.add('selected');
          item.querySelector('input').setAttribute('checked', true);
        } else if (!isFirstItem) {
          item.classList.remove('selected');
          item.querySelector('input').removeAttribute('checked');
        }
      }

      item.addEventListener('click', () => {

        if (!item.classList.contains('selected')) {

          //card select behaviour
          item.classList.toggle('selected');
          item.querySelector('input').setAttribute('checked', true);
          document.querySelectorAll(this.SELECTORS.item).forEach((otherEl) => {
            if (otherEl.id !== item.id) {
              otherEl.classList.remove('selected');
              otherEl.querySelector('input').removeAttribute('checked');
            }
          });

          //if not link card and sku populated
          if (item.dataset.isLink == 'false' && (item.dataset.products || isFirstItem)) {
            // reset filters
            this.FiltersComponent.resetFilters();
            this.FiltersComponent.filterQuery(false);
            if (!isFirstItem) {
              this.showBreadcrumbs(item.dataset.shortcutTitle);
              this.addShortcutCodeToUrl(item.dataset.shortcutCode);
            } else {
              this.removeShortcutCodeFromUrl();
            }
          }

          //if link card and href populated
          if (item.dataset.isLink == 'true' && item.dataset.href) {
            window.open(item.dataset.href, '_self');
          }
        } else if (!isFirstItem) {
          //de-select card
          item.classList.toggle('selected');
          this.hideBreadcrumbs();
          item.querySelector('input').removeAttribute('checked');
          if (this.firstShortcut) {
            if (this.firstShortcut.dataset.isLink == "false") {
              this.firstShortcut.classList.add('selected');
              this.firstShortcut.querySelector('input').setAttribute('checked', true);
            }
          }
          this.FiltersComponent.filterQuery(false);
          this.removeShortcutCodeFromUrl();
        }
      });
    });
  }

  showBreadcrumbs(title) {
    let a = this.breadcrumbsWrapper.querySelector('a.shortcut-page');
    a.innerHTML = title;

    this.breadcrumbsWrapper.querySelectorAll('.shortcut-page').forEach((el) => {
      el.style.display = 'inline-block';
    });
    this.toggleLastBreadcrumb(true);
  }

  hideBreadcrumbs() {
    this.breadcrumbsWrapper.querySelectorAll('.shortcut-page').forEach((el) => {
      el.style.display = 'none';
    });
    this.toggleLastBreadcrumb(false);
  }

  toggleLastBreadcrumb(hide) {
    // show/hide old last breadcrumb (for style)
    if (this.defaultLastBreadcrumb) {
      hide ? this.defaultLastBreadcrumb.classList.remove('--last') :
        this.defaultLastBreadcrumb.classList.add('--last');
    }
  }

  addShortcutCodeToUrl(shortcutCode) {
    if (!shortcutCode) return;

    const storageKey = `shortcut_${window.location.pathname}`;
    sessionStorage.setItem(storageKey, shortcutCode);

    this.urlParams.set('code', shortcutCode);
    const newUrl = window.location.pathname + '?' + this.urlParams.toString();
    window.history.replaceState(null, null, newUrl);
  }

  removeShortcutCodeFromUrl() {
    const storageKey = `shortcut_${window.location.pathname}`;
    sessionStorage.removeItem(storageKey);

    this.urlParams.delete('code');
    const newUrl = window.location.pathname + (this.urlParams.toString() ? '?' + this.urlParams.toString() : '');
    window.history.replaceState(null, null, newUrl);
  }

  restoreShortcutFromUrl() {
    let shortcutCode = this.urlParams.get('code') ||
                       sessionStorage.getItem(`shortcut_${window.location.pathname}`);

    if (!shortcutCode) return;

    const shortcutItem = document.querySelector(`[data-shortcut-code="${shortcutCode}"]`);
    if (!shortcutItem || shortcutItem.dataset.isLink === 'true') return;

    document.querySelectorAll(this.SELECTORS.item).forEach(item => {
      item.classList.remove('selected');
      const input = item.querySelector('input');
      if (input) {
        input.removeAttribute('checked');
        input.checked = false;
      }
    });

    shortcutItem.classList.add('selected');
    const input = shortcutItem.querySelector('input');
    if (input) {
      input.setAttribute('checked', true);
      input.checked = true;
    }

    if (shortcutItem.id !== 'shortcut_0') {
      this.showBreadcrumbs(shortcutItem.dataset.shortcutTitle);
    } else {
      this.hideBreadcrumbs();
    }

    const applyFilters = () => {
      if (this.FiltersComponent) {
        this.FiltersComponent.resetFilters();
        this.FiltersComponent.filterQuery(false);
      }
    };

    applyFilters();

  }

}
